import { useState, useEffect } from 'react';

interface BetaStatus {
  betaMode: boolean;
  waitlistUrl: string;
}

export function useBetaMode() {
  const [betaStatus, setBetaStatus] = useState<BetaStatus>({
    betaMode: false,
    waitlistUrl: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBetaStatus = async () => {
      try {
        const backendUrl = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000';
        const response = await fetch(`${backendUrl}/api/system/beta-status`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        setBetaStatus(data);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch beta status:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch beta status');
        // 默认为非内测模式
        setBetaStatus({
          betaMode: false,
          waitlistUrl: ''
        });
      } finally {
        setLoading(false);
      }
    };

    fetchBetaStatus();
  }, []);

  return { 
    ...betaStatus, 
    loading, 
    error,
    refresh: () => {
      setLoading(true);
      setError(null);
      // 重新获取状态
      const fetchBetaStatus = async () => {
        try {
          const backendUrl = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000';
          const response = await fetch(`${backendUrl}/api/system/beta-status`);
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const data = await response.json();
          setBetaStatus(data);
          setError(null);
        } catch (err) {
          console.error('Failed to fetch beta status:', err);
          setError(err instanceof Error ? err.message : 'Failed to fetch beta status');
          setBetaStatus({
            betaMode: false,
            waitlistUrl: ''
          });
        } finally {
          setLoading(false);
        }
      };
      fetchBetaStatus();
    }
  };
}
